import { Table } from 'react-bootstrap';
import styled from 'styled-components';

export const ContainerWrapper = styled.div`
    .btn-default:active, .btn-default.active {
        background-color: #133666;
        color: white;
    }

    .btn:focus {
        outline: none;
    }
`;

export const TableWrapper = styled(Table)`
    & > thead {
        box-sizing: unset;
    }
    
    & > thead > tr > th,
    & > tbody > tr > td {
        text-align: center;
        border: 1px solid #ddd;
        border-collapse: collapse;
        font-size: ${p => p.fontSize ? p.fontSize : null};
    }

    & > tbody > tr > td {
        vertical-align: middle;
    }
`;